// The resolved-proposal info grid -- window / accounts / event / categories
// -- shared by `#foundation` step 2 and `#s07` phone's summary card. Every
// value here comes from the server's resolution of the sentence; the LLM
// proposes labels, the server resolves the ids and the window (binding
// rule), so this component only ever displays strings it was given.
export function AskProposalSummary({
  window,
  accountLast4s,
  eventName,
  categories,
}: {
  window: { start: string; end: string };
  accountLast4s: string[];
  eventName: string;
  categories: string[];
}) {
  return (
    <div className="rounded-lg border border-border bg-card p-3 text-sm" data-testid="ask-proposal-summary">
      <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1.5">
        <dt className="text-muted-foreground">Window</dt>
        <dd>
          {window.start} – {window.end}
        </dd>
        <dt className="text-muted-foreground">Accounts</dt>
        <dd>{accountLast4s.map((last4) => `•${last4}`).join(', ')}</dd>
        <dt className="text-muted-foreground">Event</dt>
        <dd>{eventName}</dd>
        <dt className="text-muted-foreground">Categories</dt>
        <dd>{categories.join(' · ')}</dd>
      </dl>
    </div>
  );
}

export default AskProposalSummary;
